export const RETAILER_ID = "RETAILER_ID";
export const MESSAGE_ID = "MESSAGE_ID";
export const TAB_NAME = "TAB_NAME";
export const DEFAULT_MESSAGE = "DEFAULT_MESSAGE";
export const PAGE_TAB = "PAGE_TAB";
